/**
 * This hooks provides the different navigations.
 * You can add or remove the navigation queries.
 */
import React from "react"
import { allNavsResolver } from "utils/navigationsResolver"
import { graphql, useStaticQuery } from "gatsby"
import { useLocalization } from "gatsby-theme-i18n"

const useNavigations = () => {
  const { locale } = useLocalization()

  const data = useStaticQuery(graphql`query NavigationsQuery {
  burger: allNavBurger(sort: {order: ASC}) {
    nodes {
      locale
      page {
        to: url
        label: title
      }
      nested {
        page {
          to: url
          label: title
        }
      }
    }
  }
  shortcuts: allNavNavigationPrincipale(sort: {order: ASC}) {
    nodes {
      locale
      page {
        to: url
        label: title
      }
      nested {
        page {
          to: url
          label: title
        }
      }
    }
  }
}`)

  /**
   * Get all navigations in the right locale
   */
  return React.useMemo(() => allNavsResolver(data, locale), [data, locale])
}

export default useNavigations
